
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import ns738b664d3abac5d721ffca4ba430c2been from './en.yaml'
            i18n.addResourceBundle('en', '738b664d3abac5d721ffca4ba430c2be', flattenObject(ns738b664d3abac5d721ffca4ba430c2been), true, true);
        
        export default '738b664d3abac5d721ffca4ba430c2be';
    